import React from 'react';
import './LeaderAccount.css';

export default function LeaderAccount(){


    return(
        <div className='leader-account-container'>
            <div className='leader-account-card'>
                Cannot load leader account details
                </div>
        </div>
    )
}